import { render, staticRenderFns } from "./exercise-view.vue?vue&type=template&id=25f3912c&scoped=true&"
import script from "./exercise-view.vue?vue&type=script&lang=js&"
export * from "./exercise-view.vue?vue&type=script&lang=js&"
import style0 from "./exercise-view.vue?vue&type=style&index=0&id=25f3912c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3912c",
  null
  
)

export default component.exports